import {
  Button,
  FormControl,
  FormHelperText,
  FormLabel,
  OutlinedInput
} from '@mui/material';
import { useErrorMessage } from '@shared/hooks/use-error-message';
import React from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import InfoTooltip from '@shared/components/info-tooltip/info-tooltip';
import useDeviceStore from '../../store/devices.store';
import {
  trimFormValues,
  validateNotOnlySpaces
} from '@shared/utils/trim-form-values-utils';
import { digitalSignageCodeErrorMessages } from '@modules/digital-signage/utils/digital-signage.utils';

const CodeDialogForm: React.FC<{
  onSave: (data: { code: string }) => void;
}> = ({ onSave }) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isValid }
  } = useForm<{ code: string }>({ mode: 'onTouched' });

  const getErrorMessage = useErrorMessage();

  const { t } = useTranslation();
  const { isLoading } = useDeviceStore();

  const handleSave: SubmitHandler<{ code: string }> = (data) => {
    const trimmedData = trimFormValues(data);

    onSave(trimmedData);
  };

  return (
    <div>
      <form className="flex flex-col gap-1" onSubmit={handleSubmit(handleSave)}>
        <FormControl error={!!errors.code}>
          <FormLabel className="flex">
            <span className="reuqired-symbole">*</span>
            {t('label_code')}
            <InfoTooltip text="tooltip_info_room_tvs_code" />
          </FormLabel>
          <OutlinedInput
            {...register('code', {
              required: true,
              validate: {
                notOnlySpaces: validateNotOnlySpaces
              }
            })}
            error={!!errors.code}
            placeholder={t('placeholder_digital_signage_enter_code')}
          />
          <FormHelperText>
            {errors?.code &&
              getErrorMessage({
                errors,
                fieldName: 'code',
                errorMessages: digitalSignageCodeErrorMessages
              })}
          </FormHelperText>
        </FormControl>

        <div className="flex justify-end items-center gap-6">
          <Button
            type="submit"
            disabled={!isValid}
            variant="contained"
            loading={isLoading()}
          >
            {t('save')}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default CodeDialogForm;
